import { deepMerge } from '../../../utils/deepMerge'
import { CartListProps } from './CartList.types'
import { defaultProps } from './CartList.defaultProps'
import { IProduct } from '../../../interfaces/catalog'

export const mergeCartListProps = (props: CartListProps): CartListProps => {
  const cartProps = deepMerge(defaultProps, props)
  const { itemCard = {}, price, deleteActions } = cartProps
  const itemCardProps = deepMerge(
    {
      layout: 'cart',
      price,
      sideContent: {
        map: {
          deleteButton: {
            props: {
              actions: deleteActions
            }
          }
        }
      }
    },
    itemCard
  )
  return {
    ...cartProps,
    itemCard: itemCardProps
  }
}

export const cartHasPackages = (cart: IProduct[]): boolean =>
  cart.some((item) => item.package)
